import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { SlackConfigurationFooter } from './components/SlackConfigurationFooter';
import { SlackConfigurationForm } from './components/SlackConfigurationForm';
import type { SlackConfigurationFormValues } from './SlackConfigurationFormSchema';
import { SlackConfigurationFormSchema } from './SlackConfigurationFormSchema';

export const ConfigureSlackComponents: FormDrawerProps<ZodSchema<SlackConfigurationFormValues>> = {
  zodSchema: SlackConfigurationFormSchema,
  ContentComponent: SlackConfigurationForm,
  Footer: SlackConfigurationFooter,
}; 